import { render, staticRenderFns } from "./VideoHeaderView.vue?vue&type=template&id=0983bd3b"
import script from "./VideoHeaderView.vue?vue&type=script&lang=js"
export * from "./VideoHeaderView.vue?vue&type=script&lang=js"
import style0 from "./VideoHeaderView.vue?vue&type=style&index=0&id=0983bd3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports